<template>
  <span
    class="rounded text-xs py-1 px-3"
    :class="tagClass"
  >
    {{ text }}
  </span>
</template>

<script>
export default {
  name: "PortalLightTag",

  props: {
    text: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: "gray",
      validator: (value) => ["gray", "yellow", "blue", "green", "red"].includes(value),
    },
  },

  emits: [],

  computed: {
    tagClass() {
      if (this.type === "yellow") {
        return "text-yellow-700 bg-orange-100"
      } else if (this.type === "blue") {
        return "text-blue-700 bg-blue-100"
      } else if (this.type === "green") {
        return "text-green-800 bg-green-100"
      } else if (this.type === "red") {
        return "text-red-700 bg-red-100"
      } else if (this.type === "gray") {
        return "text-gray-700 bg-gray-100"
      }
    },
  },
}
</script>

<style scoped></style>
